import { jwtDecode } from "jwt-decode";

export const getJwtClaims = () => {
  const token = localStorage.getItem("access_token");
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch (e) {
    console.error("Invalid JWT", e);
    return null;
  }
};

export const getUserRoleFromToken = () => {
  const claims = getJwtClaims();
  return claims?.role?.toLowerCase();
};

export const isSuperAdminFromToken = () => {
  const claims = getJwtClaims();
  return claims?.is_superadmin === true;
};

export const isAdminFromToken = () => {
  const role = getUserRoleFromToken();
  return role === "admin" || role === "superadmin" || isSuperAdminFromToken();
};

export const getUserIdFromToken = () => {
  const claims = getJwtClaims();
  return claims?.sub; // IDENTITY is usually in 'sub'
};
